import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import Panel from '@ts-core/components/Panel/Panel';
import Dialog from '@ts-core/components/Dialog';

import GroupsList from '../../components/GroupsList';
import GroupForm from '../../components/GroupForm';

const GroupsPanel = (props) => {
  const {
    groups,
    selectedGroupId,
    addingGroup,
    editingGroup,
    onSelectGroup,
    onOpenAddGroupDialog,
    onOpenEditGroupDialog,
    onSubmitGroupForm,
    onRemoveGroup,
    loading,
    showSelectedMark,
    dialogProps,
  } = props;

  return (
    <>
      <Panel>
        <Box display="flex" flexDirection="row">
          <Typography variant="subtitle2">
            <FormattedMessage id="groups" />
          </Typography>
          <Box flexGrow={1} />
          <Button onClick={onOpenAddGroupDialog} color="secondary">
            <Typography variant="subtitle2">
              <FormattedMessage id="button.addGroup" />
            </Typography>
          </Button>
        </Box>
        <GroupsList
          groups={groups}
          loading={loading}
          selectedGroupId={selectedGroupId}
          showSelectedMark={showSelectedMark}
          onSelectGroup={onSelectGroup}
          onEditGroup={onOpenEditGroupDialog}
          onRemoveGroup={onRemoveGroup}
        />
      </Panel>
      <Dialog {...dialogProps}>
        {(data) => <GroupForm groupFormData={data?.groupInput} onSubmit={onSubmitGroupForm} isSubmitting={addingGroup || editingGroup} />}
      </Dialog>
    </>
  );
};

GroupsPanel.propTypes = {
  groups: PropTypes.array,
  loading: PropTypes.bool,
  showSelectedMark: PropTypes.bool,
  selectedGroupId: PropTypes.string,

  addingGroup: PropTypes.bool,
  editingGroup: PropTypes.bool,
  onOpenEditGroupDialog: PropTypes.func.isRequired,
  onOpenAddGroupDialog: PropTypes.func.isRequired,

  onSubmitGroupForm: PropTypes.func.isRequired,
  onSelectGroup: PropTypes.func.isRequired,
  onRemoveGroup: PropTypes.func.isRequired,

  dialogProps: PropTypes.object.isRequired,
};

GroupsPanel.defaultProps = {
  groups: [],
  loading: false,
  showSelectedMark: false,
  selectedGroupId: undefined,
  addingGroup: false,
  editingGroup: false,
};

export default GroupsPanel;
